export interface IPromocionImpresion {
  nombre: string;
  contenido: string;
}

export const buildPromocionesHtml = (promociones: IPromocionImpresion[]): string => {
  let html = '';

  for (const promo of promociones) {
    html +=
      '<div class="rule" style="border-top:2px dashed #000; margin:4px 0; width:100%;"></div>\n';
    html +=
      '<div style="text-align:center; margin:4px 0; font-family:\'Courier New\', Courier, monospace; color:#000;">\n';
    html += `<p style="font-size:16px; font-weight:700; margin:2px 0;">--- ${promo.nombre.toUpperCase()} ---</p>\n`;
    html += `<div style="font-size:12px; font-weight:700; margin:4px 0;">${promo.contenido}</div>\n`;
    html += '</div>\n';
  }

  return html;
};

export const extractPromocionesImpresion = (
  jobData: Record<string, any>,
): IPromocionImpresion[] => {
  const promocionesRaw = jobData?.['promociones'];
  if (!Array.isArray(promocionesRaw)) return [];

  return promocionesRaw
    .filter(
      (promo) =>
        !!promo && typeof promo['nombre'] === 'string' && typeof promo['contenido'] === 'string',
    )
    .map((promo) => ({
      nombre: promo['nombre'],
      contenido: promo['contenido'],
    }));
};
